const AdminOrders = () => {
  return (
    <section className='admin-orders-sec'>
      <h2 className='is-size-5 mb-5'>Orders</h2>
      <div className='block'>
        <div className='box'></div>
        <div className='box'></div>
        <div className='box'></div>
      </div>
    </section>
  );
};

export default AdminOrders;
